import Vue from 'vue'

// Vuesax Component Framework
import Vuesax from 'vuesax'
Vue.use(Vuesax)

import app from './app'
Vue.use(app)


// Auth0 Plugin
import AuthPlugin from "./auth/index";
Vue.use(AuthPlugin);

// Vuexy Admin Filters
import './filters/filters'

import './directive'

// VeeValidate
import './validator'
// import VeeValidate from 'vee-validate';
// Vue.use(VeeValidate);

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

// Globally Registered Components
import './globalComponents.js'

// Theme Configurations
import './themeConfig.js'

import modals from '@/modals'
import Modal from './modal'
Vue.use(Modal, modals)